import React, { useState, useRef, useEffect } from "react";

import _ from 'lodash';

const ContentCardTemplateWidget = () => {
  return false;
};

ContentCardTemplateWidget.moveableConfig = (widget) => {
  return {
    draggable: false,
    resizable: false,
    rotatable: false,
    renderDirections: []
  };
};

ContentCardTemplateWidget.processRequest = (widget) => {
  var background = _.get(widget, 'properties.desktop.background');

  if (!background) {
    return widget;
  }

  var media = _.get(background, 'media');
  if (media) {
    background = {
      ...background,
      media: media.id
    }
  }

  return {
    ...widget,
    properties: {
      ...widget.properties,
      desktop: {
        ...widget.properties.desktop,
        background: background
      }
    }
  }
}

export { ContentCardTemplateWidget };